<template>
    <div class="nav-wrapper" :class="{'slideup' : !isMobileMenuOpen, 'slidedown' : isMobileMenuOpen}">
        <nav class="ie o-menu o-menu__icon-mob--active"
            :class="{ 'o-menu--collapse': isMenuCollapsed }"
            @mouseleave="unforce">
            <icons></icons>
            <div class="o-menu__icon" @click="updateMenu(false)"
                :class="{ 'o-menu__icon--animate o-menu--show-sub-menu': isMenuOpen && !this.forceMenu &&  this.getSubMenu.allSteps.length }">
                <span @click="force"></span>
            </div>
            <div class="o-menu__collapse-menu" @click="collapseMenu"
                :class="{ 'o-menu__collapse-menu--show': isMenuOpen && !this.forceMenu &&  this.getSubMenu.allSteps.length }"></div>
            <div class="o-menu__icon-mob--close" @click="updateMobileMenu"></div>
            <div class="o-menu__m-top-level-nav"
                :class="{ 'o-menu__m-top-level-nav--active': isMenuOpen && !this.forceMenu &&  this.getSubMenu.allSteps.length }">
                <ul class="top-nav-links" v-if="getUserId !== null">
                    <li @click="updateMobileMenu">
                        <router-link :to="{ name: 'homepage' }" exact active-class="o-menu__m-top-level-nav--item-active">
                            <p>
                                Homepage
                            </p>
                        </router-link>
                    </li>
                    <li @click="updateMobileMenu">
                        <router-link :to="{ name: 'executive-dashboard' }" active-class="o-menu__m-top-level-nav--item-active">
                            <p>
                                Executive Dashboard
                            </p>
                        </router-link>
                    </li>
                    <li id="reserving" class="has-sub" :class="{'remove-border' : currentSubMenu == 'reserving-sub'}">
                        <a>
                            Reserving
                        </a>
                        <!-- wrapping the svg in a div and having the rotation animation on the div (rather than on the svg) fixes an ie11 bug -->
                        <div class="o-menu__m-top-level-nav--sub-menu-icon" :class="{'rotate' : currentSubMenu == 'reserving-sub'}">
                            <svg viewBox="0 0 120 120">
                                <use xlink:href="#arrow-head"></use>
                            </svg>
                        </div>
                        <ul id="reserving-sub" class="sub" v-show="currentSubMenu === 'reserving-sub'">
                            <li @click="updateMobileMenu">
                                <router-link :to="{ name: 'compare' }" active-class="o-menu__m-top-level-nav--item-active">
                                    <p>
                                        Reserve vs Paid Comparison
                                    </p>
                                </router-link>
                            </li>
                            <li @click="updateMobileMenu">
                                <router-link :to="{ name: 'reserving::day-one-assessment' }" active-class="o-menu__m-top-level-nav--item-active">
                                    <p>
                                        Day One Assessment
                                    </p>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li id="discount-rate" class="has-sub" :class="{'remove-border' : currentSubMenu == 'discount-rate-sub'}">
                        <a>
                            Discount Rate
                        </a>
                        <!-- wrapping the svg in a div and having the rotation animation on the div (rather than on the svg) fixes an ie11 bug -->
                        <div class="o-menu__m-top-level-nav--sub-menu-icon" :class="{'rotate' : currentSubMenu == 'discount-rate-sub'}">
                            <svg viewBox="0 0 120 120">
                                <use xlink:href="#arrow-head"></use>
                            </svg>
                        </div>
                        <ul id="discount-rate-sub'" class="sub" v-show="currentSubMenu === 'discount-rate-sub'">
                            <li @click="updateMobileMenu">
                                <router-link :to="{ name: 'discount-rate-comparison' }" active-class="o-menu__m-top-level-nav--item-active">
                                    <p>
                                        Discount Rate Comparison
                                    </p>
                                </router-link>
                            </li>
                            <li @click="updateMobileMenu">
                                <router-link :to="{ name: 'update-discount-rate' }" active-class="o-menu__m-top-level-nav--item-active">
                                    <p>
                                        Update Discount Rates
                                    </p>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li id="claims" class="has-sub" :class="{'remove-border' : currentSubMenu == 'claims-sub'}">
                        <a>
                            Claims
                        </a>
                        <!-- wrapping the svg in a div and having the rotation animation on the div (rather than on the svg) fixes an ie11 bug -->
                        <div class="o-menu__m-top-level-nav--sub-menu-icon" :class="{'rotate' : currentSubMenu == 'claims-sub'}">
                            <svg viewBox="0 0 120 120">
                                <use xlink:href="#arrow-head"></use>
                            </svg>
                        </div>
                        <ul id="claims-sub" class="sub" v-show="currentSubMenu === 'claims-sub'">
                            <li @click="updateMobileMenu">
                                <router-link :to="{ name: 'claims' }" active-class="o-menu__m-top-level-nav--item-active">
                                    <p>
                                        Claims Dashboard
                                    </p>
                                </router-link>
                            </li>
                            <li @click="updateMobileMenu">
                                <router-link :to="{ name: 'fatal::dependency.step-1' }" active-class="o-menu__m-top-level-nav--item-active">
                                    <p @click="fetchSubMenu('fatal/dependency')">
                                        Fatal Accident Dependency Claim
                                    </p>
                                </router-link>
                            </li>
                            <li @click="updateMobileMenu">
                                <router-link :to="{ name: 'fatal::estate.step-1' }" active-class="o-menu__m-top-level-nav--item-active">
                                    <p @click="fetchSubMenu('fatal/estate')">
                                        Fatal Accident Estate Claim
                                    </p>
                                </router-link>
                            </li>
                            <li @click="updateMobileMenu">
                                <router-link :to="{ name: 'lost::step-1' }" active-class="o-menu__m-top-level-nav--item-active">
                                    <p @click="fetchSubMenu('lost')">
                                        Lost Years Claim
                                    </p>
                                </router-link>
                            </li>
                            <li @click="updateMobileMenu">
                                <router-link :to="{ name: 'personal::step-1' }" active-class="o-menu__m-top-level-nav--item-active">
                                    <p @click="fetchSubMenu('personal')">
                                        Personal Injury Claim
                                    </p>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li @click="updateMobileMenu">
                        <router-link :to="{ name: 'mini-calculators' }" active-class="o-menu__m-top-level-nav--item-active">
                            <p @click="fetchSubMenu('mini')">
                                Mini Calculators
                            </p>
                        </router-link>
                    </li>
                    <li @click="updateMobileMenu">
                        <router-link :to="{ name: 'randt::documents' }" active-class="o-menu__m-top-level-nav--item-active">
                            <p>Resources and Tools</p>
                        </router-link>
                    </li>
                    <li @click="updateMobileMenu">
                        <router-link :to="{ name: 'support' }" active-class="o-menu__m-top-level-nav--item-active">
                            <p>Support</p>
                        </router-link>
                    </li>
                    <!-- <li>
                        <router-link :to="{ name: 'your-account' }" active-class="o-menu__m-top-level-nav--item-active">
                            <p>Your Account</p>
                        </router-link>
                    </li> -->
                    <li @click="updateMobileMenu">
                        <a href="#" @click="logoutUser()">
                            <p>Logout
                                <span style="margin-top: -3px; margin-left: 20px" :disabled="running" :class="[loggingOut() ?'a-loader--white':'']"></span>
                            </p>
                        </a>
                    </li>
                </ul>
                <ul class="top-nav-links" v-if="getUserId === null">
                    <li @click="updateMobileMenu">
                        <router-link :to="{ name: 'homepage' }" exact active-class="o-menu__m-top-level-nav--item-active">
                            <p>Homepage</p>
                        </router-link>
                    </li>
                    <li @click="updateMobileMenu(); updatePassportMenu();">
                        <a href="#" class="loginButton" @click="openPassport()">
                            <p>Login</p>
                        </a>
                    </li>
                </ul>
            </div>

            <div class="o-menu__m-sub-nav">
                <ul>
                    <li v-for="(item, index) in this.getSubMenu.allSteps" v-if="item.route.path">
                        <router-link :to="item.route" active-class="o-menu__m-sub-nav--active" v-if="item.route.path !== 'documents'"
                                    :class="{ 'o-menu__m-sub-nav--visited': item.valid === true }">
                            <p>{{ item.name }} </p>
                        </router-link>
                    </li>
                </ul>
            </div>
            <div class="o-menu__back-button">
                <p>Main Menu</p>
            </div>
        </nav>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import passport from 'mixins/passport';
    import Icons from 'components/Icons';

    export default {
        name: 'navigation',
        components: {Icons},
        mixins: [
            passport,
        ],
        computed: {
            ...mapGetters('menu', [
                'isMenuOpen',
                'isMobileMenuOpen',
                'isMenuCollapsed',
                'getSubMenu',
                'subMenuStatus',
                'isPassportOpen'
            ]),
            ...mapGetters('user', [
                'getUserId',
            ]),
            ...mapGetters('http', [
                'running',
                'apiRouteRequestRunning'
            ]),
        },
        data(){
            return {
                forceMenu: false,
                topMenuSubMenuOpen: false,
                currentSubMenu: ''
            };
        },
        methods: {
            ...mapActions('menu', [
                'reset',
                'updateMenu',
                'updateMobileMenu',
                'collapseMenu',
                'updateSubMenu',
                'updatePassportMenu'
            ]),
            ...mapActions('user', [ 'logoutUser' ]),
            isRoute (route) {
                return !!this.$route.matched.filter(function (matched) {
                    return (matched.path.indexOf(route) !== -1 || matched.name === route);
                }).length;
            },
            isRouteByName (routeName) {
                return this.$route.name == routeName;
            },
            force(){
                this.forceMenu = true;
            },
            unforce() {
                this.forceMenu = false;
            },
            fetchSubMenu(menu) {
                this.updateMenu(true);
                this.updateSubMenu(menu);
            },
            loggingOut() {
                return this.apiRouteRequestRunning('/api/v1/auth/logout')
            },
            addSubClicks() {
                let clickListener = (e) => {
                    if(e.currentTarget.id && this.currentSubMenu != e.currentTarget.id + '-sub') {
                        this.currentSubMenu = e.currentTarget.id + '-sub';
                    }
                    else {
                        this.currentSubMenu = '';
                    }
                }

                let listItems = document.querySelectorAll('.top-nav-links li');

                listItems.forEach(clickElement => clickElement.addEventListener('click', clickListener));
            },
            goHome() {
                this.$router.push({name: 'homepage'});
            }
        },
        watch : {
            getUserId: function(newId, oldId) {
                let self = this;

                setTimeout(function (){ self.addSubClicks(); }, 1000);

                if (!newId) {
                    self.goHome();
                }
            },
        },
        mounted() {
            this.reset();
            setTimeout(() => { this.addSubClicks(); }, 1000);
        }
    }
</script>

<style>
    .slideup, .slidedown {
        max-height: 0;            
        overflow-y: hidden;
        -webkit-transition: max-height 0.8s ease-in-out;
        -moz-transition: max-height 0.8s ease-in-out;
        -o-transition: max-height 0.8s ease-in-out;
        transition: max-height 0.8s ease-in-out;
    }
    .slidedown {            
        max-height: 1000px;                    
    }
</style>



// WEBPACK FOOTER //
// Navigation.vue?6cc5132f